import React from 'react';
import { Box, Typography } from '@mui/material';
import MicOffIndicator from './MicOffIndicator';

/**
 * Participant Avatar Component
 * Displays participant avatar with optional mic indicator
 */
function ParticipantAvatar({ 
  image, 
  name, 
  isMuted = false, 
  size = 'large',
  showName = true,
  helperText = null 
}) {
  const sizes = {
    small: { width: 60, height: 60 },
    medium: { width: 120, height: 120 },
    large: { width: 200, height: 200 },
  };

  const avatarSize = sizes[size] || sizes.large;

  return (
    <Box sx={{ textAlign: 'center', color: 'white' }}>
      <Box
        sx={{
          position: 'relative',
          width: avatarSize.width,
          height: avatarSize.height,
          borderRadius: '50%',
          overflow: 'hidden',
          mb: showName ? 2 : 0,
          border: size === 'small' ? '2px solid white' : '4px solid white',
        }}
      >
        <img
          src={image}
          alt={name}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
        
        {isMuted && (
          <MicOffIndicator 
            size={size === 'small' ? 'small' : size === 'medium' ? 'medium' : 'large'} 
          />
        )}
      </Box>
      
      {showName && (
        <>
          <Typography variant={size === 'small' ? 'caption' : 'h6'}>
            {name}
          </Typography>
          {helperText && (
            <Typography 
              variant={size === 'small' ? 'caption' : 'body2'} 
              sx={{ mt: 1, opacity: 0.7 }}
            >
              {helperText}
            </Typography>
          )}
        </>
      )}
    </Box>
  );
}

export default ParticipantAvatar;
